import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderDropDownResponse } from 'src/app/models/order-drop-down-response.model';
import { OrderMessage } from 'src/app/models/order-message.model copy';
import { OrderRequest } from 'src/app/models/orders-request.model';
import { createHttpParams } from 'src/app/shared/utils/create-http-params.utils';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersService extends BaseService<any> {
  constructor(protected http: HttpClient) {
    super(http, 'orders');
  }

  submitOrders(body: any): Observable<HttpResponse<OrderRequest>> {
    return this.http.post<OrderRequest>(`${this.resourceUrl}`, body, {
      observe: 'response'
    });
  }

  downloadOrders(searchValues: any): Observable<HttpResponse<{ data: any }>> {
    const params = createHttpParams(searchValues);
    return this.http.get<{ data: string }>(`${this.resourceUrl}/download`, {
      params,
      observe: 'response'
    });
  }

  getOrdersDropDown(): Observable<HttpResponse<OrderDropDownResponse>> {
    return this.http.get<OrderDropDownResponse>(
      `${this.resourceUrl}/drop-down`,
      {
        observe: 'response'
      }
    );
  }

  getOrderMessageById(
    id: number | string | undefined
  ): Observable<HttpResponse<OrderMessage>> {
    return this.http.get<OrderMessage>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }
}
